import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Faq } from '../models/Faq';

@Injectable()
export class FaqService {
  baseUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/`;
  headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders();
  }

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    if (token) {
      return new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });
    }
    return new HttpHeaders();
  }

  getAllFaqs() {
    return this.http.get<Faq[]>(this.baseUrl + 'Faqs');
  }

  addFaq(faq: Faq) {
  return this.http.post<Faq>(this.baseUrl + 'Faqs', faq);
  }

  updateFaq(faq: Faq) {
    return this.http.post<Faq>(this.baseUrl + 'Faqs/' + faq.id, faq);
  }

  deleteFaq(id: number) {
    return this.http.delete<void>(this.baseUrl + 'Faqs/' + id);
  }
}
